import { TuiDrawer } from '@taiga-ui/kit';
import { TuiAppBar } from '@taiga-ui/layout';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AsyncPipe, NgClass } from '@angular/common';
import { SidebarComponent } from '@core/components/sidebar/sidebar.component';
import { RequestFormChangeStatusButtonComponent } from '@features/requests';
import { DeviceDetectorService } from '@core/services/device-detector';
import { asapScheduler } from 'rxjs';
import { TuiButton, TuiLink, TuiPopup, TuiScrollbar } from '@taiga-ui/core';
import { Title } from '@angular/platform-browser';
import { OutkeepTranslateService } from '@core/services/outkeep-translate.service';
import { NavigationService } from '@core/services';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { AppVersionComponent, ProfileComponent } from '../';
import { PwaInstallButtonComponent } from '../pwa-install-button/pwa-install-button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '@common/components/svg-icon/svg-icon.component';

@Component({
  selector: 'x-main-layout',
  imports: [
    SvgIconComponent,
    SidebarComponent,
    TuiAppBar,
    TuiScrollbar,
    AsyncPipe,
    TuiButton,
    RequestFormChangeStatusButtonComponent,
    AppVersionComponent,
    ProfileComponent,
    PwaInstallButtonComponent,
    RouterLink,
    NgClass,
    TuiDrawer,
    TuiPopup,
    TuiLink,
    TranslatePipe,
  ],
  templateUrl: './main-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent implements OnInit {
  readonly deviceService = inject(DeviceDetectorService);
  readonly router = inject(Router);
  readonly navigationService = inject(NavigationService);
  protected readonly permissionService = inject(OutkeepPermissionService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly titleService = inject(Title);
  private readonly outkeepTranslateService = inject(OutkeepTranslateService);

  public $isDesktopSidebarOpen = signal(false);
  public $navbarHeader = this.navigationService.$navbarHeader;
  public $canGoBack = this.navigationService.$canGoBack;
  public $isRequestPage = this.navigationService.$isRequestPage;

  public ngOnInit(): void {
    this.setNavbarHeader();
  }

  public setNavbarHeader() {
    // set title right after language changes
    this.outkeepTranslateService
      .onLangChange()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        asapScheduler.schedule(() => {
          const title = this.titleService.getTitle().split('X-Outkeep | ')[1];

          this.navigationService.$navbarHeader.set(title || '');
        });
      });
  }

  public toggleSidebar(open: boolean) {
    this.$isDesktopSidebarOpen.set(open);
  }
}
